import { Action } from '@ngrx/store';
import {Filters} from '../../models/filters';

export enum FilterActionTypes {
  GetModuleFilters = '[Filter] Get Module Filters',
  GetNodeFilters = '[Filter] Get Node Filters'
}

export class GetModuleFilters implements Action {
  readonly type = FilterActionTypes.GetModuleFilters;
  constructor(public payload: Filters) {}
}


export class GetNodeFilters implements Action {
  readonly type = FilterActionTypes.GetNodeFilters;
  constructor(public payload: Filters) {}
}


export type FilterActions = GetModuleFilters
  | GetNodeFilters;
